module.exports = __webpack_public_path__ + "media/src/images/icons/white-minus-cef079c0a4be9bc45a7f4d1a0f9403c3.svg";